import script from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"

import "./CallToAction.vue?vue&type=style&index=0&id=3bf6cbf0&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf6cbf0"]])

export default __exports__